export enum EApiHttpMethod {
  Post = 0,
  Get = 1,
  Put = 2,
  Delete = 3,
  Patch = 4
}
